module.exports = __webpack_public_path__ + "static/me_comp-e72d4357c3d0c979596d053c25a33e6a.jpg";